type AuditDateTimeProps={value:string|null|undefined;label:string};

function utcAuditInstant(value:string):Date|null{
  const match=/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,6}))?(Z)?$/.exec(value);
  if(!match||(value.includes('T')&&!match[8])||(value.includes(' ')&&match[8]))return null;
  const [,year,month,day,hour,minute,second,fraction='']=match;
  const milliseconds=(fraction+'000').slice(0,3);
  const instant=new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}.${milliseconds}Z`);
  if(Number.isNaN(instant.getTime())
    ||instant.getUTCFullYear()!==Number(year)||instant.getUTCMonth()+1!==Number(month)||instant.getUTCDate()!==Number(day)
    ||instant.getUTCHours()!==Number(hour)||instant.getUTCMinutes()!==Number(minute)||instant.getUTCSeconds()!==Number(second))return null;
  return instant;
}

export function AuditDateTime({value,label}:AuditDateTimeProps){
  const instant=typeof value==='string'?utcAuditInstant(value):null;
  if(!instant)return <span>{label}: unavailable.</span>;
  const zone=Intl.DateTimeFormat().resolvedOptions().timeZone||'UTC';
  const local=new Intl.DateTimeFormat(undefined,{year:'numeric',month:'short',day:'numeric',hour:'numeric',minute:'2-digit',second:'2-digit',timeZone:zone}).format(instant);
  return <>
    <span>{label}: <time dateTime={instant.toISOString()}>{local} ({zone})</time>.</span>
    <details><summary>Exact UTC audit time</summary><code>{value}</code></details>
  </>;
}
